import { render } from "./DrainOptions.vue?vue&type=template&id=1efd7836&scoped=true"
import script from "./DrainOptions.vue?vue&type=script&lang=js"
export * from "./DrainOptions.vue?vue&type=script&lang=js"

import "./DrainOptions.vue?vue&type=style&index=0&id=1efd7836&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efd7836"]])

export default __exports__